import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { FancyStateIcon } from '../fancy-state-icon';
import { ChildrenPropType } from '../../../prop-types/children';
import style from './style.module.less';

/**
 * @deprecated Use `Alert` from `@mantine/core` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 */
export const InlineErrorMessage = ({ className = '', state, children }) => (
  <div className={classnames(style['error-message'], style[state], className)}>
    <div className={style['icon-and-label']}>
      <div className={style['state-icon']}>
        <FancyStateIcon state={state} />
      </div>
    </div>
    <div className={style['children-wrapper']}>{children}</div>
  </div>
);

InlineErrorMessage.propTypes = {
  className: PropTypes.string,
  state: PropTypes.oneOf(['error', 'warning']).isRequired,
  children: ChildrenPropType.isRequired,
};
